<rid-syllabic-keyboard-assignments
  class="h-full"
  name="Klankbord plus | pas de regel toe"
  [layout]="{
    KLINKERS: 'ENABLED',
    LANGE_KLINKERS: 'ENABLED',
    KORTE_LANGE_KLINKERS: 'ENABLED',
    SPACE: 'HIDDEN',
    DUBBELE_KLINKERS: 'ENABLED',
    DRIEDUBBELE_KLINKERS: 'ENABLED',
    VIERDUBBELE_KLINKERS: 'ENABLED',
    MEDEKLINKERS: 'ENABLED',
    EXOTEN: 'HIDDEN',
    SJWAS: 'ENABLED',
    KLANKVOET: 'HIDDEN',
    RULE: 'HIDDEN',
  }"
  mode="KLANK"
  [prompts]="prompts()"
  (finished)="finished.emit()"
/>
